import React, { useEffect, useState, useMemo } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './scss/main.scss';
import Home from './pages/home';
import Loader from "./components/Loader";
import { WOW } from 'wowjs';
import "animate.css"; 
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Cookies  from './components/Cookies';
import ForgotPasswordPage from './pages/token/forgotPassword';
import ResetPasswordPage from './pages/token/resetPassword';
import Checkout from './pages/token/checkout';
import SigninPage from './pages/token/signin';
import SignupPage from './pages/token/signup';
import RizznetTokenPage from './pages/token/rizznetTOken';
import RedirectPage from './pages/token/redirect';
import TransactionsPage from './pages/token/transaction'
import TokenHome from './pages/token/home';
import NewsAndArticles from './components/News&Articles';
import StakingPage from './pages/token/staking';
import VerifyEmailPage from './pages/token/verifyEmail'
import ConnectWalletPage from './pages/token/connectWallet';
import QuickBuyToken from './pages/token/quickBuyToken';
import WalleetPayment from './pages/token/walletPayment';
import { createAppKit } from '@reown/appkit/react'
import { networks, projectId, metadata, ethersAdapter, solanaWeb3JsAdapter } from './config'
import ClaimTokens from './pages/token/claimTokens';
import PaymentFailedPage from './pages/token/paymentFailure';
import PaymentSuccessPage from './pages/token/paymentSuccess';
import QuickBuyPaymentSuccessPage from './pages/token/quickBuyPaymentSuccess';
import QuickBuyPaymentFailedPage from './pages/token/quickBuyPaymentFailure';
import PaymentStatusdPage from './pages/token/paymentStatus';
import QuickBuyPaymentStatusPage from './pages/token/quickBuyPaymentStatus';



export default function App() {
  const [loading, setLoading] = useState(true);
    useEffect(() => {
      new WOW().init();
      setTimeout(() => setLoading(false), 1000);
    }, []);


// Create a AppKit instance
createAppKit({
  adapters: [ethersAdapter, solanaWeb3JsAdapter],
  networks,
   metadata,
  projectId,
  features: {
    analytics: true,
    telemetry: true,
    email: false,
    socials: false,
  },
  });

  return (
    <Router>
      {loading ? <Loader /> : (
        <>
            <Routes>        
              <Route path="/" element={<Home />} />
              {/* <Route path="*" element={<Navigate to="/" />} /> */}

              <Route path="/token" element={<TokenHome />} />
              <Route path="/token/checkout" element={<Checkout />} />
              <Route path="/token/signin" element={<SigninPage />} />
              <Route path="/token/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/forgot-password/token?" element={<ResetPasswordPage />} />
              <Route path="/token/rzto" element={<RizznetTokenPage />} />
              <Route path="/token/transactions" element={<TransactionsPage />} />
              <Route path="/token/staking" element={<StakingPage />} />
              <Route exact path="/token/redirect" element={<RedirectPage />} />

              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path = "/news&articles" element ={ <NewsAndArticles/>} />
              <Route path = "/token/verify-email" element = { <VerifyEmailPage/>} />
              <Route path = "/token/connect-wallet" element = { <ConnectWalletPage/>} />
              <Route path="/token/quick-buy" element = {<QuickBuyToken/>} />
              <Route path='/token/wallet-payment' element = {<WalleetPayment/>} />
              <Route path="/token/claim-token" element={<ClaimTokens />} />

              <Route path='/token/payment/success' element={<PaymentSuccessPage/>} />
              <Route path='/token/payment/failed' element = {<PaymentFailedPage />} />
              <Route path='/token/quick-buy/payment/success' element={<QuickBuyPaymentSuccessPage/>} />
              <Route path='/token/quick-buy/payment/failed' element = {<QuickBuyPaymentFailedPage />} />
              <Route path='/token/payment/status' element = {<PaymentStatusdPage/>} />
              <Route path='/token/quick-buy/payment/status' element = {<QuickBuyPaymentStatusPage/>}/>

            </Routes>
        </>
      )}
    </Router>
  );
}

